import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="mx-auto max-w-[720px] px-5 md:px-10 py-24 text-center" data-testid="not-found-page">
      <Compass className="mx-auto h-8 w-8 text-primary" strokeWidth={1.8} />
      <h1 className="mt-6 font-display text-4xl sm:text-5xl">This page has moved out</h1>
      <p className="mt-3 text-sm text-muted-foreground">
        The link you followed doesn't exist. Let's get you back to the listings.
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link to="/">
          <Button className="h-12 rounded-lg px-6 font-bold hover:brightness-95" data-testid="not-found-home-btn">
            Back to home
          </Button>
        </Link>
        <Link to="/properties">
          <Button variant="outline" className="h-12 rounded-lg px-6 font-bold" data-testid="not-found-search-btn">
            Browse properties
          </Button>
        </Link>
      </div>
    </div>
  );
}
